/**
 * Created by daniel.gonzalez on 6/11/15.
 */

'use strict';

var Backbone = require('dibs-backbone');
var marinate = require('dibs-baseview-marinate');
var baseMixin = require('../mixins/baseMixin');
var fullscreenMixin = require('../mixins/fullscreenMixin');
var trackingMixin = require('../mixins/trackingMixin');
var templates = require('../../../templates/global/mobileAds/mobile-ad-fullscreen');
var LogoIcon = require('dibs-vg/dist/templateString/logo-no-reg');
var CloseIcon = require('dibs-vg/dist/templateString/close');

var FullscreenView = Backbone.BaseView.extend({
    className : 'mobile-ad-fullscreen-container',
    template : templates.fullscreen,

    initialize: function (options) {
        this._adName = options.adName;
    },

    render: function () {
        this.$el.html(this.template({
            logoIcon: LogoIcon,
            closeIcon: CloseIcon
        }));
        this.trackingOnRender();
    },

    events: {
        'click .mobile-ad-fullscreen-close-container': 'closeAd',
        'click .mobile-ad-fullscreen-deep-link-link': 'redirectToApp'
    }
});

marinate(FullscreenView, baseMixin, fullscreenMixin, trackingMixin);

module.exports = FullscreenView;



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/mobileAds/views/FullscreenView.js
// module id = 2565
// module chunks = 62